'use client'

import DynamicIcon, { IconName } from '@/components/DynamicIcon'
import { Button } from '@/components/ui/button'
import { useWinsContext } from '@/providers/WinsProvider'
import { cn } from '@/utilities/ui'

import type { Topic } from '@/payload-types'

const FilterButton = ({
  topic,
  handleTopicClick,
  activeTopics,
}: {
  topic: Topic
  handleTopicClick: (topic: Topic) => void
  activeTopics: Topic[]
}) => {
  const { winTopicCounts, isFetchingTopicCounts } = useWinsContext()

  // Use server-provided counts (accurate even beyond the 1000 item limit)
  const totalItems = winTopicCounts[topic.id] ?? 0

  const isSelected = activeTopics.some((t) => t.id === topic.id)

  return (
    <Button
      variant="filter"
      className={cn(isSelected && 'selected')}
      onClick={() => handleTopicClick(topic)}
      disabled={Boolean(totalItems === 0) ?? undefined}
    >
      <span className="flex items-center gap-2">
        <DynamicIcon name={topic.icon as IconName} className="size-4.5" />
        {topic.title}
      </span>
      <span className={cn('text-xs font-normal', isFetchingTopicCounts && 'animate-pulse')}>
        {isFetchingTopicCounts ? '-' : totalItems}
      </span>
    </Button>
  )
}

export default FilterButton
